angular.module('zc.zenclerkS')
  .component('zcsCampaignEditStepCoupon', {
    templateUrl: '/templates/zenclerk_s/sites/campaigns/edit/campaign_edit_step_coupon.html',
    require: {
      campaignEdit: '^zcsCampaignEdit'
    },
    controller: ZcsCampaignEditStepCouponController
  });

ZcsCampaignEditStepCouponController.$inject = ['$location', '$rootScope', '$scope', '$state', '$uibModal', '$translate', 'ZcsEstimator', 'ZcsIncentive', 'ZcsSegment', 'ZcsCampaignElementCreator', 'ZcsProject', 'ZcsOemService', 'currencies'];
function ZcsCampaignEditStepCouponController($location, $rootScope, $scope, $state, $uibModal, $translate, ZcsEstimator, ZcsIncentive, ZcsSegment, ZcsCampaignElementCreator, ZcsProject, ZcsOemService, currencies) {
  const vm = this;
  vm.ZcsOemService = ZcsOemService;

  let incentiveType;

  this.$onInit = () => {
    // variables
    vm.campaign = vm.campaignEdit.campaign;
    vm.project = vm.campaignEdit.project;
    vm.currency = currencies[vm.project.currency];

    if(!_.get(vm.campaign, 'segment_id')) {
      $state.go('zenclerkS.project.campaign.edit.segment', { apikey: vm.project.apikey, campaignId: vm.campaign.id });
      // We need to return or message gets set on reload, and might cause
      // problems!
      return;
    }

    vm.estimatedCv = ZcsSegment.estimatedCv;
    vm.setFreeShippingCost = setFreeShippingCost;
    vm.incentivePlans = [];

    if(vm.campaignEdit.isIntegratedWithMakeshop) {
      vm.couponCodePattern = /^[a-zA-Z0-9]+$/;
    } else {
      vm.couponCodePattern = /^[a-zA-Z0-9\-_]+$/;
    }

    vm.availableCoupons = {
      type: {
        price: {
          label: {
            prefix: vm.currency.symbol,
            suffix: vm.currency.suffix,
          },
          suffix: 'OFF',
          amount: ZcsIncentive.getRecommendedFixedPriceCoupons(vm.project),
          min: 10,
          max: 50000,
          onSelect: incentive => {
            incentive.discount_type = 'price';
            incentive.discount_price = undefined;
            incentive.discount_percent = undefined;
            incentive.is_free_shipping = false;
          }
        },
        percent: {
          label: {
            prefix: '',
            suffix: '%',
          },
          suffix: 'OFF',
          amount: ZcsIncentive.getRecommendedPercentCoupons(vm.project),
          min: 1,
          max: 99,
          onSelect: incentive => {
            incentive.discount_type = 'percent';
            incentive.discount_price = undefined;
            incentive.discount_percent = undefined;
            incentive.is_free_shipping = false;
          }
        },
        free_shipping: {
          label: {
            prefix: '',
            suffix: $translate.instant('sites.campaigns.edit.campaignEdit.stepCoupon.freeShipping'),
          },
          onSelect: incentive => {
            incentive.discount_type = undefined;
            incentive.discount_price = undefined;
            incentive.discount_percent = undefined;
            incentive.is_free_shipping = true;
          }
        }
      },
      couponMinLength: 2,
      couponMaxLength: 20,
    };

    // actions
    vm.selectIncentiveDiscountAmount = selectIncentiveDiscountAmount;
    vm.switchPriceLimit = switchPriceLimit;
    vm.getMinimumPriceLimit = ZcsIncentive.getMinimumPriceLimit;

    if(vm.campaign.status === 'incomplete') {
      vm.incentive = vm.campaign.incentive_draft;
      incentiveType = 'draft';
    } else {
      vm.incentive = vm.campaign.incentives[0];
      incentiveType = 'normal';
    }

    vm.setProfitAndConversion = setProfitAndConversion;

    $scope.$watch('$ctrl.incentive', incentiveUpdated, true);
  };

  function incentiveUpdated(newValue, oldValue) {
    if(angular.equals(newValue, oldValue)) {
      return;
    }

    if(incentiveType === 'draft') {
      vm.campaign.incentive_draft = _.merge(vm.campaign.incentive_draft, newValue);
      vm.campaign.incentive_draft.name = ZcsIncentive.getName(vm.campaign.incentive_draft);
    } else if(vm.campaign.incentives.length > 0) {
      vm.campaign.incentives[0] = _.merge(vm.campaign.incentives[0], newValue);
      vm.campaign.incentives[0].name = ZcsIncentive.getName(vm.campaign.incentives[0]);
    }

    // If design is not set yet, create it. Otherwise update just the texts.
    // This way colors and designs won't reset every time
    if(_.get(vm.campaign, 'element.message')) {
      const isUpdateCodeTitleOnly = isWhitelistedParameterChanged(newValue, oldValue);
      ZcsCampaignElementCreator.setDefaultMessageValues(vm.campaign, vm.project, isUpdateCodeTitleOnly);
    } else {
      ZcsCampaignElementCreator.createCampaignElement(vm.campaign, vm.project);
    }
  }

  function isWhitelistedParameterChanged(newParams, oldParams) {
    const whitelistedParameters = [
      'coupon_code',
      'name',
      'is_price_limit_tax_included',
    ];
    return _.some(whitelistedParameters, parameter => {
      const newValue = _.get(newParams, parameter);
      const oldValue = _.get(oldParams, parameter);
      return !_.isEqual(newValue, oldValue);
    });
  }

  function selectIncentiveDiscountAmount(amount) {
    vm.incentive['discount_' + vm.incentive.discount_type] = amount;
  }

  function switchPriceLimit() {
    if(vm.campaign.status !== 'incomplete') {
      return false;
    }
    vm.incentive.has_price_limit = !vm.incentive.has_price_limit;

    if(!vm.incentive.has_price_limit) {
      vm.incentive.minimum_price = null;
    }
  }

  function setFreeShippingCost() {
    const modalInstance = $uibModal.open({
      templateUrl: '/templates/zenclerk_s/directives/project/free_shipping_cost_editor/free_shipping_cost_editor.html',
      controller: 'ZcsFreeShippingCostEditorController',
      controllerAs: '$ctrl',
      size: 'sm',
      resolve: {
        project: vm.project
      }
    });

    modalInstance.result.then(() => {
      // no need to do anything
    });
  }

  function setProfitAndConversion() {
    const modalInstance = $uibModal.open({
      templateUrl: '/templates/zenclerk_s/sites/campaigns/edit/campaign_edit_modal_conversion_price.html',
      controller: 'ZcsCampaignEditModalConversionPriceController',
      controllerAs: '$ctrl',
      size: 'sm',
      resolve: {
        project: vm.project
      }
    });

    modalInstance.result.then(() => {
      // update the recommended price and percent values
      vm.availableCoupons.type.price.amount = ZcsIncentive.getRecommendedFixedPriceCoupons(vm.project);
      vm.availableCoupons.type.percent.amount = ZcsIncentive.getRecommendedPercentCoupons(vm.project);
    });
  }
}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/sites/campaigns/edit/campaign_edit_step_coupon.js